import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { dayNightCo2PreheatMapping } from '../Constants/constants';

export function AddInfo({ className, time, phase }) {
  const { t } = useTranslation();

  const displayText = [
    time !== undefined && time,
    phase !== undefined && t(dayNightCo2PreheatMapping[phase ?? -1])
  ]
    .filter(Boolean)
    .join(' · ');

  return <Typography className={className} style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{displayText || null}</Typography>;
}
